import { Sparkles } from 'lucide-react';

export interface AllyTriggerProps {
  onOpen: () => void;
  label: string;
}

export function AllyTrigger({ onOpen, label }: AllyTriggerProps) {
  return (
    <button className="ally__pill" onClick={onOpen} type="button">
      {label} <Sparkles size={14} className="spark" />
    </button>
  );
}
